<ideal-drawer position="left" [open]="menuIsOpen()">
  <ideal-render-target-app-primary-menu />
</ideal-drawer>
